import { render, staticRenderFns } from "./OperatorPrivilege.vue?vue&type=template&id=9621f9ea&scoped=true"
import script from "./OperatorPrivilege.vue?vue&type=script&lang=js"
export * from "./OperatorPrivilege.vue?vue&type=script&lang=js"
import style0 from "./OperatorPrivilege.vue?vue&type=style&index=0&id=9621f9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9621f9ea",
  null
  
)

export default component.exports